/*
 * Description of what this file is for
 *
 * @package  baukasten
 * @author David Hellmann [davidhellmann.com@gmail.com]
 * tickets
 */

const tickets = {
    // Config
    cfg: {
        body: document.body,
        triggers: [...document.querySelectorAll('.js-ticketsTab')],
        wrapper: document.querySelector('.js-ticketsContent'),
        status: 'is-open'
    },

    // Toggle Content
    toggleContent(event) {
        event.preventDefault();
        const target = event.currentTarget;
        // eslint-disable-next-line
        const tabContent = document.getElementById('ticketTab'+target.dataset.tab); // target.nextElementSibling;
        const allTabs = this.cfg.wrapper.querySelectorAll('.js-ticket');

        if (!target.classList.contains(this.cfg.status)) {
            allTabs.forEach((tab) => {
                tab.classList.remove(this.cfg.status);
            });
            this.cfg.triggers.forEach((trigger) => {
                trigger.classList.remove(this.cfg.status);
            });
            target.classList.add(this.cfg.status);
            tabContent.classList.add(this.cfg.status);
        }
    },

    // Init
    init() {
        this.cfg.triggers.forEach((trigger) => {
            trigger.addEventListener('click', (event) => {
                this.toggleContent(event);
            });
        });
    }
};

export default tickets;



// WEBPACK FOOTER //
// ./___src/templates/_molecules/tickets/_script.js